/**
 * Model used to hold a key and value pair. Typcially used
 * to hold an enum key and it's display value.
 */
export class KeyValuePair {
    public key: string = null;
    public value: any = null;

    /**
     * Constructor
     */
    constructor(key: string, value: any) {
        this.key = key;
        this.value = value;
    }

    /**
     * Clone the model. Used to prevent object reference issues.
     */
    public clone(): KeyValuePair {
        return new KeyValuePair(this.key, this.value);
    }
}
